import { STATUS_STAFF } from "../constants/webapp";
import { UserRegister } from "./users/UserRegister";

export const Staff = () => {
  return (
    <div>
      {/* <CreateDrawer title={sAddCustomer} form={<UserForm />} /> */}
      <h3>Staff Register</h3>
      <UserRegister status={STATUS_STAFF} />
    </div>
  );
};
